import PaginationBar from './PaginationBar';

export default PaginationBar;
export { PAGE_SIZES } from './PaginationBar';
